import React from 'react';
import HomePage from './HomePage';
import PublicPage from '../components/PublicPages';

// Standalone marketing entry (no App bundle). Rendered for logged-out visitors on marketing paths.
export default function MarketingSite({ onRequestApp }) {
  const path = window.location.pathname;
  return path === '/' ? <HomePage onRequestApp={onRequestApp} /> : <PublicPage path={path} />;
}
